import React from 'react'
import { Button, Form, Radio } from 'semantic-ui-react'

import styled from "styled-components";
import { ErrorMessage } from "formik";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class WorkFormA extends React.Component<any, any> {

  next = (e: any) => {
    e.preventDefault();
    this.props.gaEvent('event', '6Years', 'Next', 'Boots', this.props.isValid);
    this.props.nextStep(this.props);
  }

  render() {
    return (
      <React.Fragment>
        <Form.Group grouped data-testid='wfa-form-group'>
          <label>In the past 6 years, have you worked in a Boots store in England or Wales on an hourly rate (or the last 5 years in Scotland)?</label>
          <Form.Field data-testid='wfa-form-field'>
            <Radio
              label='Yes'
              name='stp1_worked'
              value='yes'
              checked={this.props.values.stp1_worked === 'yes'}
              onChange={() => this.props.setFieldValue("stp1_worked", "yes")}
              data-testid='wfa-radio-yes'
              className='yes'
            />
          </Form.Field>
          <Form.Field data-testid='wfa-form-field'>
            <Radio
              label='No'
              name='stp1_worked'
              value='no'
              checked={this.props.values.stp1_worked === 'no'}
              onChange={() => this.props.setFieldValue("stp1_worked", "no")}
              data-testid='wfa-radio-no'
              className='no'
            />
          </Form.Field>
        </Form.Group>

        <ErrorMessage
          name={'stp1_worked'}
          render={msg => <RedText className="error" data-testid='wfa-error-message'> {msg} </RedText>}
        />

        <Button.Group widths="2" data-testid='wfa-button-group'>
          <Button labelPosition='right' floated='right' color={this.props.isValid ? 'green' : 'grey'} icon='right chevron' content='Next' onClick={this.next} data-testid='wfa-button' />
        </Button.Group>

      </React.Fragment>
    )
  }
}

export default WorkFormA;